import { Component, inject } from '@angular/core';
import { TractionTypeService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  TractionTypeCreateDto,
  TractionTypeDto,
  TractionTypeExcelDownloadDto,
  TractionTypeUpdateDto,
} from '../proxy/general/dtos/traction-type';
import { TRACTIONTYPE_CONFIG, TRACTIONTYPE_FIELDS } from './traction-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-traction-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, TractionTypeService, ConfirmationService],
  templateUrl: './traction-type.html',
  styleUrl: './traction-type.scss',
})
export class TractionType extends BaseCrudComponent<
  TractionTypeDto,
  TractionTypeCreateDto,
  TractionTypeUpdateDto,
  TractionTypeExcelDownloadDto
> {
  service = inject(TractionTypeService);
  config = TRACTIONTYPE_CONFIG;
  fields = TRACTIONTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: TractionTypeDto): TractionTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'TractionType';
  }
}
